import { FormActionDef, FormDefine } from '@/libs/formHelper/form/type'
import { GenealogyApplyQuery } from '@/api/genealogy/GenealogyApplyQuery'
import { GenealogyApply } from '@/api/genealogy/GenealogyApply'

export default function getFormDefine (
  view: any
): FormDefine<GenealogyApplyQuery> {
  const items = [
    {
      title: '姓名',
      clearable: true,
      hideLabel: true,
      key: 'nameLk'
    },
    {
      title: '手机号',
      clearable: true,
      hideLabel: true,
      key: 'phoneLk'
    }
    // {
    //   title: '族谱',
    //   clearable: true,
    //   hideLabel: true,
    //   key: 'genealogyName'
    // }
  ]

  const actions: FormActionDef<GenealogyApply>[] = [
    {
      key: 'search',
      title: '查询',
      button: 'primary',
      icon: 'ios-search',
      onClick: (_item: GenealogyApply) => {
        view.onSearch()
      }
    }
  ]

  return {
    items,
    actions,
    enterTrigger: view.onSearch
  }
}
